<script setup lang="ts">
import PageFooter from '@/application/components/PageFooter.vue';
</script>

<template>
  <!--
    Used only inside <IonContent>, which is its own scroll container. The footer
    lives inside that scroll flow (min-h-full pushes it to the bottom edge when
    content is short, below the content when it overflows). Routes using this
    wrapper set meta.footerInContent so MainLayout skips the shared footer.
  -->
  <div class="flex flex-col min-h-full">
    <div class="flex flex-col grow bg-gray-50">
      <div class="container flex flex-col gap-1 grow pb-5 md:pb-10">
        <slot />
      </div>
    </div>

    <PageFooter />
  </div>
</template>
